const styles = {
  circle: {
    width: 10,
    height: 10,
    borderRadius: "50%",
    display: "inline-block",
    marginRight: 6
  }
};

export {
  styles
}
